import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import { Button, Card, CardBody, Row, Col, Input } from "reactstrap";
import { Typography, FormGroup } from "@material-ui/core";
import { AvForm, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation";
import InputMask from "react-input-mask";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert/lib/dist/SweetAlert";
import Modal from "react-responsive-modal";
import moment from "moment";

import CreateInterest from "../../mutations/CreateInterest";

import "./IsInterestedModal.css";

class IsInterestedModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aereo: false,
      traslado: false,
      alquiler: false,
      alert: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.createAppointee = this.createAppointee.bind(this);
  }

  handleValidSubmit() {
    this.createAppointee();
  }

  render() {
    const { isInterested, setIsInterested } = this.props;
    return (
      <Modal open={isInterested} onClose={() => setIsInterested(false)}>
        {this.state.alert}
        <Card>
          <CardBody className="text-center">
            <Row>
              <Col>
                <br />
                <Typography>Favor de proveer la siguiente información</Typography>
                <br />
                <AvForm onValidSubmit={this.handleValidSubmit}>
                  <Typography>Nombre</Typography>
                  <AvField
                    name="name"
                    id="name"
                    type="text"
                    value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Porfavor escriba su nombre",
                      },
                      pattern: {
                        value: "^([A-Za-z]+ )+[A-Za-z]+$|^[A-Za-z]+$",
                        errorMessage: "Solo letras para su nombre",
                      },
                      maxLength: {
                        value: 50,
                      },
                    }}
                  />
                  <Typography>Email</Typography>
                  <AvField
                    name="email"
                    id="email"
                    type="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Porfavor escriba un email",
                      },
                      pattern: {
                        value: "^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$",
                        errorMessage: "Favor de insertar un email válido",
                      },
                      maxLength: {
                        value: 256,
                      },
                    }}
                  />
                  <Typography>Teléfono</Typography>
                  <AvField
                    name="phone"
                    id="phone"
                    type="tel"
                    maskChar="_"
                    mask="999-999-9999"
                    tag={[Input, InputMask]}
                    value={this.state.number}
                    onChange={(e) => {
                      this.setState({ number: e.target.value });
                    }}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Porfavor escriba un número de télefono",
                      },
                      pattern: {
                        value: "^([0-9-]{0,12}$)",
                        errorMessage: "Favor de insertar un télefono válido",
                      },
                    }}
                  />
                  <Typography>Haz una marca en la caja si deseas que te incluyan los siguientes servicios:</Typography>
                  <AvCheckboxGroup className="avCheckBoxGroup" inline name="extraServices">
                    <AvCheckbox
                      label="Aéreo"
                      value="Aereo"
                      onChange={(e) => {
                        this.setState({ aereo: !this.state.aereo });
                      }}
                    />
                    <AvCheckbox
                      label="Traslados"
                      value="Traslados"
                      onChange={(e) => {
                        this.setState({ traslado: !this.state.traslado });
                      }}
                    />
                    <AvCheckbox
                      label="Alquiler de auto"
                      value="Alquiler de auto"
                      onChange={(e) => {
                        this.setState({ alquiler: !this.state.alquiler });
                      }}
                    />
                  </AvCheckboxGroup>
                  <FormGroup>
                    <Button color="secondary" className="mt-2">
                      ENVIAR
                    </Button>
                  </FormGroup>
                </AvForm>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
    );
  }

  createAppointee = async () => {
    const { aereo, traslado, alquiler, name } = this.state;
    const { data, filters, setIsInterested } = this.props;

    let { children, childrenAmount, childrenTxtBoxes, adults, departure, arrival } = filters ? filters : {};
    const adultsTxt = parseInt(adults) === 0 ? "No especificó número de adultos" : adults;
    const ages = childrenTxtBoxes?.sort((a, b) => a - b);
    let childrenTxtArray = [];
    if (ages) {
      for (let i = 0; i < ages.length; i++) {
        if (parseInt(ages[i]) !== 0) {
          childrenTxtArray.push(`<span>${ages[i]} año(s)</span>`);
        }
      }
    }
    const finalChildrenTxt = childrenAmount > 1 ? childrenTxtArray.join(", ") : childrenTxtArray[0];
    const extraServices = aereo || traslado || alquiler;
    const txtAereo = aereo ? "<p>Aereo</p>" : "";
    const txtTraslado = traslado ? "<p>Traslado</p>" : "";
    const txtAlquiler = alquiler ? "<p>Alquiler de Auto</p>" : "";
    let emailHtml = `
    <p>Equipo de ventas</p><br/>
    <p>En ${moment().locale("es_US").format("MMMM D, YYYY")}, ${name} le intereso una de las ofertas para sus vacaciones; require de más información y/o cotización formal.</p>
    <br/>
    <p>Medios de contacto son: </p>
    <p>EMAIL: ${this.state.email}
    <p>TÉLEFONO: ${this.state.number}</p>
    <br/>
    <p>Interesado en: </p>
    <p>${data.name}</p><p>Codigo de Oferta: ${data.offerId ? data.offerId : "No asignado"}</p>
    <p>Check In y Check Out: ${moment(arrival ? arrival : data.checkInDate)
      .locale("es_US")
      .format("MMMM D, YYYY")} - ${moment(departure ? departure : data.checkOutDate)
      .locale("es_US")
      .format("MMMM D, YYYY")}</p>
    <br/>
    ${
      filters
        ? `
      <p>Información del grupo:</p>
      <p>Adultos: ${adultsTxt}</p>
      ${children !== "false" ? `<p>${childrenAmount} niño(s) de:</p> ${finalChildrenTxt}` : ""}
      <br/>
      <br/>
      ${extraServices ? `<p>A ${name} también le interesa que le incluyan en su oferta los siguientes servicios:</p> ${txtAereo}${txtTraslado}${txtAlquiler}` : ``}
      `
        : "<p>Escogido en las recomendaciones.</p>"
    }
    `;
    var body = {
      from: process.env.REACT_APP_SESACCESSKEY,
      email: process.env.REACT_APP_TO_EMAIL,
      subject: "Interés en Oferta",
      text: emailHtml,
      sesAccessKey: process.env.REACT_APP_SESACCESSKEY,
      sesSecretKey: process.env.REACT_APP_SESSECRETKEY,
    };
    let api = process.env.REACT_APP_API + "/sendEmail";
    axios.post(api, { body });
    this._createInterest();
    this.setState({
      alert: (
        <SweetAlert
          success
          title={`!Gracias, ${this.state.name}!`}
          onConfirm={() => {
            this.setState({ alert: null });
            setIsInterested(false);
          }}
          closeOnClickOutside={true}
        >
          Uno de nuestros agentes se comunicará para más detalles sobre esta oferta.
        </SweetAlert>
      ),
    });
  };

  _createInterest = async () => {
    const { createInterest, data, filters } = this.props;
    const { name, email, number, aereo, traslado, alquiler } = this.state;
    let variables = {
      name,
      email,
      phone: number,
      offerName: data.name,
      offerId: data.offerId,
      aereo,
      traslado,
      alquiler,
      adults: parseInt(filters.adults),
      children: parseInt(filters.childrenAmount),
      checkIn: moment(filters.arrival).format("LLLL"),
      checkOut: moment(filters.departure).format("LLLL"),
    };

    let mutationResponse = await createInterest({ variables });
    if (mutationResponse.data) {
      console.log("Interest saved!");
    }
  };
}
export default compose(graphql(CreateInterest, { name: "createInterest" }))(IsInterestedModal);
